"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 18c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5Zm0-2c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M16.855 2.495A1.06 1.06 0 0 0 15.95 2H8.06c-.368 0-.69.18-.878.452a.82.82 0 0 0-.092.118L6.125 4H.82C.37 4 0 4.45 0 5v16c0 .55.41 1 .92 1h22.16c.51 0 .92-.45.92-1a1 1 0 0 0 0-.06V5h-.002a.985.985 0 0 0-.018-.155c-.067-.477-.436-.845-.87-.845h-5.235l-.965-1.43a.834.834 0 0 0-.055-.075ZM22 6h-4.618a1.01 1.01 0 0 1-.174-.001.796.796 0 0 1-.326-.092.852.852 0 0 1-.332-.297L15.463 4H8.537L7.45 5.61a.853.853 0 0 1-.612.38.67.67 0 0 1-.118.01H2v14h20V6Z",
    clipRule: "evenodd"
  })]
});